<template>
  <ValidationProvider
    v-slot="{ errors }"
    v-bind="validationAttr"
  >
    <BFormGroup
      v-bind="formGroupAttr"
      :label-for="inputID"
    >
      <VSelect
        v-model="proxyValue"
        v-bind="$attrs"
        :input-id="inputID"
        :calculate-position="calculateDropPosition"
        :class="[{ 'is-invalid': errors.length > 0 }]"
        append-to-body
        clearable
        @search="(searchValue, loaderCallback) => $emit('search', searchValue, loaderCallback)"
      >
        <template
          v-for="(_slotCallback, slotName) in $scopedSlots"
          #[slotName]="slotProperties"
        >
          <slot
            :name="slotName"
            v-bind="slotProperties"
          />
        </template>

        <template #no-options="">
          no available options
        </template>
      </VSelect>
      <div
        v-if="(errors.length > 0)"
        class="invalid-feedback"
        v-text="errors[0]"
      />
    </BFormGroup>
  </ValidationProvider>
</template>
<script>
import MxMisc from '@/mixins/misc'

export default {
  name: 'WVVSelect',

  mixins: [
    MxMisc
  ],

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number, Object],
      default: ''
    },
    validationAttr: {
      type: Object,
      default: () => ({})
    },
    formGroupAttr: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['input', 'search'],

  data () {
    return {
      proxyValue: '',
      inputID: `WVID_${String(this.generateId(10)).toUpperCase()}_${this._uid}`
    }
  },

  watch: {
    value (val) {
      this.proxyValue = val
    },
    proxyValue (val) {
      this.$emit('input', val)
    }
  },

  mounted () {
    this.proxyValue = this.value
  }
}
</script>
